import * as React from 'react'
import { ISettingItem } from '../../types'
import SettingList from './SettingList'

interface IItemModelListSettingGroup {
  groupCategory: string
  items: ISettingItem[]
}

interface IGroupModelListSettingGroup {
  groupCategory: string
  items: IItemModelListSettingGroup[]
}

interface IModelListProps {
  settingsGroup: IGroupModelListSettingGroup[]
  baseUrl: string
}

export default class ModelList extends React.Component<IModelListProps> {
  public render() {
    return (
      <div>
        {this.props.settingsGroup.map(({ groupCategory, items }) => (
          <div id={`model-group-${groupCategory}`} key={`model-group-${groupCategory}`}>
            <div className='h2 mt2 mb2'>{groupCategory}</div>
            <div className='clearfix'>
              {items.map(({ groupCategory, items }) => (
                <div className='col col-4'>
                  <p className='h5 bold pl2 font-black'>{groupCategory}</p>
                  <div className='pl2 pr2'>
                    <SettingList baseUrl={this.props.baseUrl} settings={items} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/ModelList.tsx